var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('HeaderComponent'),_c('div',{staticClass:"main-content"},[_c('transition',{attrs:{"name":"page-fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1)],1),_c('FooterComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }